import Dexie from 'dexie';

export class WorkBillLocalDb extends Dexie {
  constructor() {
    super('workbill_local');
    this.version(1).stores({
      billQueue: 'draftId, syncStatus, createdAt, businessId',
    });
    this.version(2).stores({
      billQueue: 'draftId, syncStatus, createdAt, businessId',
      submissions: '&requestId, [businessId+actorUid], [businessId+actorUid+state], state, createdAt, nextAttemptAt',
      acknowledgements: '&requestId, [businessId+actorUid], committedAt',
      drafts: '&key, [businessId+actorUid], updatedAt',
      runtimeCache: '&key, [businessId+actorUid], kind, updatedAt',
      quarantine: '&key, createdAt',
    });
  }
}

export const localDb = new WorkBillLocalDb();
